export enum TokenType {
  Rfid,
  Evcoid,
  VisualId,
  DirectPayment,
  Emaid
}

export enum LimitedTokenType {
  Rfid,
  Evcoid,
  VisualId
}
